import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configCategoriesList_template } from "../components/templates/configCategoriesList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class config_categories extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: configCategoriesList_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "config_Categories";
    }

    buildContent() : Array<Element>{

        this.elementsList = new configCategoriesList_template( "list", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Categories");

        return [ this.elementsList.build()];
    }

    public fillPage() : void{

        this.filterList();
    }

    protected onShowActiveCategories(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));


        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/categories/get/";

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.elementsList.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);


        this.XHRHdl.onReadyStateFunction = this.onGetCategoriesReturn;
        this.XHRHdl.execute();
    }

    protected onGetCategoriesReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        let brandId = this.getBrandId();
        // set categories list
        let categoriesToSet = [];
        for (let item of responseParsed.data) {
            categoriesToSet.push( {
                id: item.id,
                emakiView: '/brand/' + brandId + '/categorization/categories/view/' + item.id + '/',
                name: item.name,
                slug : item.slug,
                description : item.description ? item.description : '',
                articleCount: item.articleCount ? item.articleCount : "0",
                isSelectable : item.isSelectable ? true : false

            } )
        }

        this.elementsList.setCategories(categoriesToSet);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.elementsList.pagination.setNumberItemToPaginate(responseParsed.totalCount);
    }

    protected categoryListReorder() {

        this.filterList();
    }

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.elementsList.pagination.getTemplateViewModel().pageNumber(1);
    }

    // required from template [logsList_template]
    protected paginationOnPageClick(){
        this.filterList();
    }

    // required from template [logsList_template]
    protected filterSimpleOnChange(){
        this.resetPageNumber();
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected viewCategory(id){

        this.saveViewModule(this.getMemoryViewModel());
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page('/brand/' + idBrand + '/categorization/categories/view/'+id);
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.categories;

        return templateViewModel;
    }

    private getBrandId() {
        return this.getVnAppZone().getApp().params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_categories.ts